import React from "react";
import LoginLink from "./LoginLink";
import { VariantProps } from ".";
import Standard from "../Price";

const X = ({ selectedProduct }: VariantProps) => {
  return (
    <div className="map map-override mapW">
      <Standard
        price={selectedProduct.price.price}
        unitOfMeasure={selectedProduct.unitOfMeasure}
        textSize="small"
      />
      {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? (
        <p className="price enter-email">
          {"Contact us or "}
          <LoginLink>
            <span className="text__link">login</span>
          </LoginLink>
          <br />
          {" for pricing"}
        </p>
      ) : (
        <p className="price enter-email">Contact us for pricing</p>
      )}
      <p className="to-see-price noborder mb-1">Call 717-392-7472</p>
    </div>
  );
};

export default X;
